import React from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  Select,
  Box,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import flagBR from "../assets/flag-br.png";
import flagUS from "../assets/flag-us.png";
import flagES from "../assets/flag-es.png";

// Exported so forms that pick a language as data (e.g. a customer's default
// language) show the same flags/labels — keep codes in sync with i18n.js and
// the backend `Language` choices (customer_service/core/choices.py).
export const languages = [
  { code: "pt", label: "Português", flag: flagBR },
  { code: "en", label: "English", flag: flagUS },
  { code: "es", label: "Español", flag: flagES },
];

export const FlagOption = ({ language }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
    <img
      src={language.flag}
      alt={language.label}
      style={{
        width: "20px",
        height: "20px",
        objectFit: "cover",
        borderRadius: "2px",
      }}
    />
    <Typography variant="body2">{language.label}</Typography>
  </Box>
);

const LanguageSelector = ({ variant = "icon" }) => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const currentLanguage =
    languages.find((lang) => lang.code === i18n.language) || languages[0];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (languageCode) => {
    i18n.changeLanguage(languageCode);
    handleClose();
  };

  if (variant === "select") {
    return (
      <Select
        value={currentLanguage.code}
        onChange={(e) => handleLanguageChange(e.target.value)}
        size="small"
        renderValue={() => <FlagOption language={currentLanguage} />}
      >
        {languages.map((language) => (
          <MenuItem key={language.code} value={language.code}>
            <FlagOption language={language} />
          </MenuItem>
        ))}
      </Select>
    );
  }

  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{
          backgroundColor: "background.paper",
          "&:hover": {
            backgroundColor: "action.hover",
          },
          padding: "4px",
        }}
      >
        <img
          src={currentLanguage.flag}
          alt={currentLanguage.label}
          style={{
            width: "24px",
            height: "24px",
            objectFit: "cover",
            borderRadius: "2px",
          }}
        />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {languages.map((language) => (
          <MenuItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            selected={language.code === i18n.language}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <img
                src={language.flag}
                alt={language.label}
                style={{
                  width: "24px",
                  height: "24px",
                  objectFit: "cover",
                  borderRadius: "2px",
                }}
              />
              <Typography>{language.label}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
